@if (selectionModel?.selected?.length == 0) {
    <small class="debug">{{ me }}</small>
    <div fxFlex fxLayout="column" style="height: 100%;">
        <div class="recent-scenes">
            <app-scene-recents [vertical]="true" [count]="5"></app-scene-recents>
        </div>
    </div>
} @else if (selectionModel.selected.length === 1) {
    @if (isSliderScene()) {
        <!-- Slider Scene Header -->
        <div class="panel-header">
            <div class="header-content">
                <div class="title-section">
                    <mat-icon class="title-icon">slideshow</mat-icon>
                    <h3 class="slider-title">{{ renderScenes[0].Player.$.label }}</h3>
                </div>
            </div>
        </div>
        <app-touch-scene-props [renderScene]="renderScenes[0]"></app-touch-scene-props>
    } @else {
        <!-- Enhanced Regular Scene Selection -->
        <div class="single-selection-container">
            <!-- Modern Header with Scene Info -->
            <div class="modern-header">
                <div class="header-content-wrapper">
                    <div class="header-icon-wrapper">
                        <fa-icon class="header-icon" [icon]="renderScenes[0].Player.$.mimeType | PipeIcon"></fa-icon>
                    </div>
                    <div class="header-info">
                        <h3 class="scene-title">{{ renderScenes[0].Player.$.label }}</h3>
                    </div>
                </div>
                <div class="header-actions">
                    @if (isPlayerAssignable) {
                        <button mat-icon-button (click)="navigateToScene(renderScenes[0])"
                                matTooltip="edit scene" class="edit-icon-button">
                            <mat-icon>edit</mat-icon>
                        </button>
                    }
                </div>
            </div>

            <!-- Quick Actions Bar -->
            @if (isPlayerAssignable) {
                <div class="quick-actions-bar">
                    <button mat-raised-button color="primary" (click)="showAddPlayerModal()" class="action-button">
                        <mat-icon>queue_play_next</mat-icon>
                        {{ 'general.registerPlayer' | transloco }}
                    </button>
                </div>
            }

            <!-- Settings Section -->
            <div class="settings-section">
                <div class="section-header">
                    <mat-icon>settings</mat-icon>
                    <span>scene properties</span>
                </div>

                <!-- Player Assignable Checkbox -->
                @if (isMimeMainPlayer && experienceLevel > experienceLevelType.BEGINNER) {
                    <div class="setting-card">
                        <mat-checkbox (change)="togglePlayerAssignable($event)"
                                      [checked]="isPlayerAssignable"
                                      class="modern-checkbox">
                            <div class="checkbox-content">
                                <fa-icon size="lg" [icon]="faPlugCircleCheck"></fa-icon>
                                <span>{{ 'general.playerAssignable' | transloco }}</span>
                            </div>
                        </mat-checkbox>
                    </div>
                }

                <!-- Name Field -->
                <div class="setting-card">
                    <mat-form-field appearance="outline" class="modern-field">
                        <mat-label>{{ 'placeholder.name' | transloco }}</mat-label>
                        <input autocomplete="off" inputrestriction="basic1" matInput
                               value="{{renderScenes[0].Player.$.label}}"
                               (keyup)="onChangeSceneName($event)" (change)="onChangeSceneName($event)">
                        <mat-icon matPrefix>label</mat-icon>
                    </mat-form-field>
                </div>

                @if (experienceLevel > experienceLevelType.BEGINNER) {
                    <!-- Access Key Field -->
                    <div class="setting-card">
                        <mat-form-field appearance="outline" class="modern-field">
                            <mat-label>{{ 'general.accessKey' | transloco }}</mat-label>
                            <mat-select (selectionChange)="changeAccessMask($event.value)" [value]="accessKey">
                                @for (item of accessMask; track item) {
                                    <mat-option [value]="item">{{ item }}</mat-option>
                                }
                            </mat-select>
                            <mat-icon matPrefix>vpn_key</mat-icon>
                        </mat-form-field>
                    </div>

                    <!-- Category Field -->
                    <div class="setting-card category-field">
                        <mat-form-field appearance="outline" class="modern-field">
                            <mat-label>{{ 'placeholder.category' | transloco }}</mat-label>
                            <input inputrestriction="basic1" matInput value="{{category}}" readonly>
                            <mat-icon matPrefix>folder</mat-icon>
                        </mat-form-field>
                        <button mat-icon-button (click)="openCategoryTree()" class="category-button">
                            <mat-icon>folder_open</mat-icon>
                        </button>
                    </div>
                }
            </div>

            <!-- Scene Preview Section -->
            @if (selectedSceneId) {
                <div class="preview-section">
                    <div class="section-header">
                        <mat-icon>visibility</mat-icon>
                        <span>scene preview</span>
                    </div>
                    <div class="preview-wrapper">
                        <div class="preview-container">
                            <app-scene-preview
                                [setSelectedSceneId]="selectedSceneId"
                                [setSceneWidth]="sceneWidth"
                                [setSceneHeight]="sceneHeight"
                                [previewWidth]="previewWidth"
                                [autoScale]="true">
                            </app-scene-preview>
                            <div class="preview-overlay">
                                <button mat-mini-fab color="primary" (click)="navigateToScene(renderScenes[0])"
                                        matTooltip="{{'general.jumpToScene' | transloco}}"
                                        matTooltipPosition="left">
                                    <mat-icon>link</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            }

            <!-- Scene Information Section -->
            @if (experienceLevel > experienceLevelType.BEGINNER) {
                <div class="info-section">
                    <div class="section-header">
                        <mat-icon>info</mat-icon>
                        <span>scene information</span>
                    </div>
                    <div class="info-list">
                        <div class="info-item">
                            <span class="info-label">ID</span>
                            <span class="info-value">{{ renderScenes[0].Player.$.id }}</span>
                        </div>
                        <div class="info-item">
                            <span class="info-label">items</span>
                            <span class="info-value">{{ renderScenes[0]?.Player.Data[0]?.Scene[0]?.Players[0]?.Player?.length || 0 }}</span>
                        </div>
                        <div class="info-item">
                            <span class="info-label">dimensions</span>
                            <span class="info-value">{{ sceneWidth }} x {{ sceneHeight }} px</span>
                        </div>
                        <div class="info-item">
                            <span class="info-label">auto scale</span>
                            <span class="info-value">{{ renderScenes[0].Player.$.autoScaling || 'off' }}</span>
                        </div>
                    </div>
                </div>
            }
        </div>
    }
} @else {
    <div class="d-flex-center props-header">
        <mat-icon style="margin-right: 10px;">check</mat-icon>
        <mat-label>Selected scenes:</mat-label>
    </div>
    <div class="d-flex-center" style="margin-left: 15px">
        <mat-form-field style="width: 210px;">
            <mat-label>{{ 'placeholder.category' | transloco }}</mat-label>
            <input inputrestriction="basic1" matInput value="{{category}}" readonly>
        </mat-form-field>
        <a mat-icon-button class="mini-button" (click)="openCategoryTree()">
            <mat-icon>folder_open</mat-icon>
        </a>
    </div>
    <mat-divider></mat-divider>
    <mat-list>
        @for (scene of renderScenes; track scene) {
            <mat-list-item>
                @if (scene.Player.$.mimeType === 'Touch') {
                    <mat-icon matListItemIcon>touch_app</mat-icon>
                } @else {
                    <fa-icon matListItemIcon [icon]="scene.Player.$.mimeType | PipeIcon"></fa-icon>
                }
                <div matListItemTitle>{{ scene.Player.$.label }}</div>
                <div
                    matListItemLine>{{ scene.Player.$?.lastModified ? (scene.Player.$?.lastModified | date) : 'date: none' }}
                </div>
                <div matListItemIcon class="action-icon-group d-flex-center">
                    <mat-icon (click)="navigateToScene(scene)" matTooltip="{{'general.jumpToScene' | transloco}}">link
                    </mat-icon>
                    <mat-icon (click)="toggleSelection(scene.Player.$.id)"
                              matTooltip="{{'general.deselect' | transloco}}">close
                    </mat-icon>
                </div>
            </mat-list-item>
            <hr />
        }
    </mat-list>
}
